export default "__VITE_ASSET__BFCFcDO7__"